export enum EventStatus {
  active = 'active',
  canceled = 'canceled',
  past = 'past',
}

export interface LocationModel {
  name: string;
  address: string;
  latitude: number;
  longitude: number;
  city?: string;
  country?: string;
  postalCode?: string;
  state?: string;
  street?: string;
  streetNumber?: string;
  subLocality?: string;
  subThoroughfare?: string;
  thoroughfare?: string;
}

export interface EventModel {
  id: string;
  name: string;
  creatorUid: string;
  createdAt: string; // ISO string
  eventDate?: string; // ISO string, optional for TBA events
  invitedUids: string[];
  votedIdeaIds: string[]; // Keep for backward compatibility
  userVotes: Record<string, Record<string, string>>; // uid -> ideaId -> vote_type
  description?: string;
  votingDeadline?: string; // ISO string
  adminUids: string[];
  eventResponses: Record<string, string>; // uid -> 'yes'|'maybe'|'no'
  status: EventStatus;
  backgroundIndex: number;
  imageName?: string;
  location?: LocationModel; // Complete location information
  isOpenEvent?: boolean; // true for public events, false for private events
}

export type EventResponse = 'yes' | 'maybe' | 'no';

export interface RSVPData {
  email: string;
  response: EventResponse;
}
